
import React, {useState}  from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './home.css';
import './Sales.css';
import { Link,useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Buffer } from 'buffer';
import useFetch from '../Components/UseFetch';
import {bankLedgerEntries} from '../HelperFx/datalinks'
import verifyToken from '../HelperFx/verifyJwt.js';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import { addCommas } from '../HelperFx/common.js';



const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
  // //Console.log(username);
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;


const eq = ' eq ';
const filter = '?$filter =';

const CustTable = () => {

  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName,userName, password} = verifyToken(jwttoken);
  //Console.log(custName,userName, password);

  // const customerLink = `${process.env.REACT_APP_API_URL}${customers}`; // Replace with the actual API URL
  const { data: payments, loading, error } = useFetch(`${REACT_DATA_URL}${bankLedgerEntries}${filter}balAccNo${eq}'${custName}'&${REACT_APP_COMPANY_URL}`, token);
  // const { data: customer, loading, error } = useFetch(customerLink, token);
  const paymentInformation = payments?.value;

  // //Console.log(salesQuoteInformation);

  const navigate = useNavigate();

  const data = paymentInformation || [];

  const [searchTerm, setSearchTerm] = useState('');

  const columns = [
    { name: 'No.',
      selector: row =>
      (
        <span
          style={{ cursor: "pointer" }}>
          {row.documentNo}
        </span> 
      ),
      sortable: true },
    { name: 'Document Date', selector: row => row.documentDate, sortable: true },
    { name: 'Posting Date', selector: row => row.postingDate, sortable: true },
    { name: 'Customer No', selector: row => row.balAccNo, sortable: true },
    { name: 'Customer Name', selector: row => row.customerName, sortable: true },
    { name: 'Currency', selector: row => row.currencyCode, sortable: true },
    { name: 'Amount LCY', selector: row => addCommas(Math.abs(row.amountLCY)), sortable: true },
    { name: 'Description', selector: row => row.description, sortable: true },
  ];
  
  const filteredData = data.filter(item => 
    item.documentNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.customerNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* <h3>Payments</h3> */}
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='table-search'
      />

      <DataTable
        // title="Items List"
        columns={columns}
        data={filteredData}
        pagination
        customStyles={{
          rows: {
            style: {
              minHeight: '33px',
            },
          },
        }}
      />
    </div>
  );
};

const Payments = () => {
  return (
    <div className="Home">
      <Nav/>
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
          {/* <Link to="/home"><MdKeyboardBackspace style={{ width: "50px"}}/></Link> */}
            <IconButton component={Link} to="/home">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>

            <span>Payments</span>
            {/* <div className="actions"> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >+ New</a> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Delete</a> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Copy</a> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Attach</a> */}
              {/* <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Print</a> */}
            {/* </div> */}
          </div>

          <div className="listTable">
            <CustTable/>

          </div>
        </div>
      </div>
      <Footer/>
  </div>
  )
}

export default Payments;